var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 450,
    viewBox: "0 0 550 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 550,
    height: 450,
    transform: "translate(1043 2676)",
    fill: "#ffe2e2",
    opacity: 0.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 56.292,
    cy: 56.292,
    r: 56.292,
    transform: "translate(0 40.629) rotate(-21.154)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Services_img_2",
    transform: "translate(-1043 -2676)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(-712.911 2605.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M1771.094,388.479s-16.624-68.928,38.416-101.5c25.547-15.12,57.9-44.594,33.024-59.756-29.654-18.076-79.378,36.565,0,60.285,116.6,34.841,126.452-211.382,249.689-193.409S2058.2,291.824,2287.35,192.061",
    transform: "translate(0.287 0)",
    fill: "none",
    stroke: "#1b1a19",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292",
    transform: "translate(1890.128 161.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1362",
    "data-name": "Rectangle 1362",
    width: 284.116,
    height: 222.44,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M2130.042,212.119s-.292,4.392-46.255,14.931-18.445,72.312-81.1,72.312-45.378,36.247-107.737,42.715h235.088Z",
    transform: "translate(-1845.927 -119.637)",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    transform: "translate(2017.531 270.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1363",
    "data-name": "Rectangle 1363",
    width: 31.729,
    height: 51.587,
    transform: "translate(0 31.729) rotate(-90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M1953.1,243.865l13.63-12.143,16.732,16.508,11.527-8.841,9.7,7.219v7.834H1953.1Z",
    transform: "translate(-1953.099 -222.712)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298",
    transform: "translate(2013.71 181.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M2005.448,189.271a27.592,27.592,0,1,1-27.591-27.592v27.592Z",
    transform: "translate(-1950.264 -157.635)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M2001.325,186.271h-27.59V158.679a27.592,27.592,0,0,1,27.59,27.592Z",
    transform: "translate(-1942.098 -158.679)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(2087.909 198.611)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    x2: 55.801,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    x2: 55.801,
    transform: "translate(0 12.349)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    x2: 55.801,
    transform: "translate(0 24.96)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300",
    transform: "translate(1936.34 233.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1364",
    "data-name": "Rectangle 1364",
    width: 11.493,
    height: 11.493,
    transform: "translate(34.479 0) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1365",
    "data-name": "Rectangle 1365",
    width: 11.493,
    height: 11.493,
    transform: "translate(34.479 11.493) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1366",
    "data-name": "Rectangle 1366",
    width: 11.493,
    height: 11.493,
    transform: "translate(34.479 22.986) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1367",
    "data-name": "Rectangle 1367",
    width: 11.493,
    height: 11.493,
    transform: "translate(34.479 34.48) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1368",
    "data-name": "Rectangle 1368",
    width: 11.493,
    height: 11.493,
    transform: "translate(34.479 45.973) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1369",
    "data-name": "Rectangle 1369",
    width: 11.493,
    height: 11.493,
    transform: "translate(34.479 57.466) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1370",
    "data-name": "Rectangle 1370",
    width: 11.493,
    height: 11.493,
    transform: "translate(45.973 0) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1371",
    "data-name": "Rectangle 1371",
    width: 11.493,
    height: 11.493,
    transform: "translate(45.973 11.493) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1372",
    "data-name": "Rectangle 1372",
    width: 11.493,
    height: 11.493,
    transform: "translate(45.973 22.986) rotate(90)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1373",
    "data-name": "Rectangle 1373",
    width: 11.493,
    height: 11.493,
    transform: "translate(45.973 34.479) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1374",
    "data-name": "Rectangle 1374",
    width: 11.493,
    height: 11.493,
    transform: "translate(45.973 45.973) rotate(90)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1375",
    "data-name": "Rectangle 1375",
    width: 11.493,
    height: 11.493,
    transform: "translate(45.973 57.466) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1376",
    "data-name": "Rectangle 1376",
    width: 11.493,
    height: 11.493,
    transform: "translate(57.466 0) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1377",
    "data-name": "Rectangle 1377",
    width: 11.493,
    height: 11.493,
    transform: "translate(57.466 11.493) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1378",
    "data-name": "Rectangle 1378",
    width: 11.493,
    height: 11.493,
    transform: "translate(57.466 22.986) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1379",
    "data-name": "Rectangle 1379",
    width: 11.493,
    height: 11.493,
    transform: "translate(57.466 34.479) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1380",
    "data-name": "Rectangle 1380",
    width: 11.493,
    height: 11.493,
    transform: "translate(57.466 45.973) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1381",
    "data-name": "Rectangle 1381",
    width: 11.493,
    height: 11.493,
    transform: "translate(57.466 57.466) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1382",
    "data-name": "Rectangle 1382",
    width: 11.493,
    height: 11.493,
    transform: "translate(22.986 0) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1383",
    "data-name": "Rectangle 1383",
    width: 11.493,
    height: 11.493,
    transform: "translate(22.986 11.493) rotate(90)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1384",
    "data-name": "Rectangle 1384",
    width: 11.493,
    height: 11.493,
    transform: "translate(22.986 22.986) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1385",
    "data-name": "Rectangle 1385",
    width: 11.493,
    height: 11.493,
    transform: "translate(22.986 34.48) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1386",
    "data-name": "Rectangle 1386",
    width: 11.493,
    height: 11.493,
    transform: "translate(22.986 45.973) rotate(90)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1387",
    "data-name": "Rectangle 1387",
    width: 11.493,
    height: 11.493,
    transform: "translate(22.986 57.466) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1388",
    "data-name": "Rectangle 1388",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 0) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1389",
    "data-name": "Rectangle 1389",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 11.493) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1390",
    "data-name": "Rectangle 1390",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 22.986) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1391",
    "data-name": "Rectangle 1391",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 34.48) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1392",
    "data-name": "Rectangle 1392",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 45.973) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1393",
    "data-name": "Rectangle 1393",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 57.466) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302",
    transform: "translate(1936.34 100.116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1394",
    "data-name": "Rectangle 1394",
    width: 57.466,
    height: 81.735,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1395",
    "data-name": "Rectangle 1395",
    width: 57.466,
    height: 16.908,
    transform: "translate(0 81.735)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 4.07,
    cy: 4.07,
    r: 4.07,
    transform: "translate(24.662 86.119)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(17.24 26.679)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1396",
    "data-name": "Rectangle 1396",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 14.189) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1397",
    "data-name": "Rectangle 1397",
    width: 11.493,
    height: 11.493,
    transform: "translate(22.986 14.189) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1398",
    "data-name": "Rectangle 1398",
    width: 11.493,
    height: 11.493,
    transform: "translate(11.493 2.696) rotate(90)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1399",
    "data-name": "Rectangle 1399",
    width: 11.493,
    height: 11.493,
    transform: "translate(25.682 0) rotate(90)",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310",
    transform: "translate(2114.904 315.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303",
    transform: "translate(113.615 114.665)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1400",
    "data-name": "Rectangle 1400",
    width: 5.82,
    height: 17.884,
    transform: "translate(0 4.115) rotate(-45)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1401",
    "data-name": "Rectangle 1401",
    width: 14.035,
    height: 67.074,
    transform: "translate(8.769 18.693) rotate(-45)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1402",
    "data-name": "Rectangle 1402",
    width: 14.035,
    height: 4.677,
    transform: "translate(8.769 18.693) rotate(-45)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 56.292,
    cy: 56.292,
    r: 56.292,
    transform: "matrix(1, -0.022, 0.022, 1, 15.318, 17.751)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1305",
    "data-name": "Group 1305",
    transform: "translate(8.445 26.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304",
    transform: "translate(0 55.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M2034.092,324.873c.849-.274,1.743-.6,2.41-.8.216-.069.415-.12.57-.156.941-.218,3.374.743,4.579,1.194,5.071,1.923,8.249,1.17,8.249,1.17l1.158-4.742s-10.789-2.864-12.578-1.971a30.969,30.969,0,0,0-4.691,3.274,9.507,9.507,0,0,0-2.133,2.173C2031.322,325.694,2032.627,325.353,2034.092,324.873Z",
    transform: "translate(-2031.604 -319.395)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M2080.547,375.571s-1.195,28.774-1.3,33.744-2.644,41.845-3.75,45.046l-6.164-.443s-.026-.512-.088-1.449l-4.448.654s-3.413-.415-3.564-.522a11.559,11.559,0,0,1-.742-1.689l8.313-5.191.062.035c-1.052-18.941-3.467-64.686-2.424-70.185C2067.768,368.62,2080.547,375.571,2080.547,375.571Z",
    transform: "translate(-2021.553 -244.953)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M2106.092,452.633l-6.164.415s-.1-.5-.283-1.423l-4.324,1.264s-3.43.053-3.6-.027a12,12,0,0,1-.964-1.565l7.508-6.3.07.027c-3.669-18.605-12.389-63.58-12.114-69.169.345-7.075,13.963-1.955,13.963-1.955s2.8,28.66,3.386,33.6S2106.746,449.307,2106.092,452.633Z",
    transform: "translate(-2012.602 -245.082)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M2074.217,299.886l.02,3.574-.2,4.488,8.834-1.163.963-1.309.077-3.41.291-3.194h-5.873Z",
    transform: "translate(-2016.842 -270.564)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M2085.519,284.025a7.324,7.324,0,0,1,7.379-.334c4.031,2.087,4.375,9.72,2.912,11.618s.274,4.3-2.714,6.822-7.873,3.625-10.812.965-1.158-8.969-1.158-8.969Z",
    transform: "translate(-2014.559 -276.141)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M2071.281,291.613a2.125,2.125,0,1,1-2.912-1.588A2.382,2.382,0,0,1,2071.281,291.613Z",
    transform: "translate(-2019.214 -273.688)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M2084.292,298.271s-.233,1.812-.386,4a9.451,9.451,0,0,1-7.187,2.074,9.274,9.274,0,0,1-2.483-.681,11.588,11.588,0,0,0-.179-3.389C2073.451,298.535,2084.292,298.271,2084.292,298.271Z",
    transform: "translate(-2016.842 -270.773)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M2071,299.622a14.29,14.29,0,0,1-.983-4.224c-.037-.338-.275-2.658-.337-2.992-.252-1.353-.442-1.131-.14-2.612a9.98,9.98,0,0,1,9.182-8.422,11.075,11.075,0,0,1,12.034,10.924,2.388,2.388,0,0,1,2.152-.191c1.318.574,1.809,2.378,1.093,4.03s-2.364,2.526-3.682,1.953a2.075,2.075,0,0,1-.5-.309",
    transform: "translate(-2018.458 -276.668)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M2069.387,285.671c1.726-7.129,11.044-7.8,11.044-7.8,14.473.349,12.776,13.136,12.395,15.254a2.363,2.363,0,0,0-1.679.372,3.886,3.886,0,0,0-.7.531c-1.724-.443-2.365-3.247-3.307-4.569-1.278-1.794-6.495-.6-8.55-1.824a4.939,4.939,0,0,1-2.352-3.24c-7.64,1.572-7.151,9.716-7.151,9.716a2.876,2.876,0,0,0-.747,0S2067.847,292.04,2069.387,285.671Z",
    transform: "translate(-2018.848 -277.871)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M2061.175,430.892l-2.107,1.371a1.16,1.16,0,0,0,.623,2.138h16a1.022,1.022,0,0,0,1.022-1.023v-3.355C2066.056,433.422,2062.377,432.389,2061.175,430.892Z",
    transform: "translate(-2022.234 -224.933)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M2090.179,431.632l-1.9,1.651a1.16,1.16,0,0,0,.911,2.031l15.842-2.215a1.023,1.023,0,0,0,.871-1.155l-.465-3.323C2095.363,433.462,2091.575,432.947,2090.179,431.632Z",
    transform: "translate(-2012.026 -225.421)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M2096.239,345.613l6.242-6.905-4.521-4.7-7.636,9.891s4.451,11.96,4.718,12.491,1.162,0,1.162,0a106.89,106.89,0,0,1-.057-10.744Z",
    transform: "translate(-2011.174 -258.34)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M2070.493,337.355s-8.243,9.227-8.944,38.822.841,40.254.841,40.254,22.629,5.517,54.141-4.909c0,0-7.762-55.963-19.169-75.039C2097.361,336.483,2084.067,328.55,2070.493,337.355Z",
    transform: "translate(-2021.249 -258.62)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M2080.523,304.441h0c-2.991.478-7.377,2.184-10.695,7.7a89.715,89.715,0,0,1-11.283,15.086l-13.4-1.5s-1.622,5.111-.81,7.418c0,0,9.786,5.859,15.459,3.99s14.96-11.034,14.96-11.034c-2.844-6.506-.9-12.329,1.467-16.3",
    transform: "translate(-2027.254 -268.627)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M2069.374,314.4s-1.952,10.8-13.632,19.273c0,0,3.136-.764,8.011-4.923l6.95-6.112Z",
    transform: "translate(-2023.205 -265.161)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M2068.674,310.41c-2.371,3.966-4.311,9.789-1.467,16.3a213.166,213.166,0,0,1,1.746,21.257s2.306,4.925,13.839,4.614,13.029-5.486,13.029-5.486,1.371-22.691,3.3-26.369c0,0,12.281,9.851,12.53,10.972s-6.421,13.464-8.666,16.207c0,0,1.558,3.457,6.857,4.689,0,0,15.461-14.663,13.278-22.018s-18.95-26.557-24.81-27.554a23.212,23.212,0,0,0-10.785.81s-5.985,3.8-11.158,1.123a11.513,11.513,0,0,0-3.394.092h0",
    transform: "translate(-2019.708 -269.227)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M2061.175,430.892l-2.107,1.371a1.16,1.16,0,0,0,.623,2.138h16a1.022,1.022,0,0,0,1.022-1.023v-3.355C2066.056,433.422,2062.377,432.389,2061.175,430.892Z",
    transform: "translate(-2022.234 -224.933)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M2090.179,431.632l-1.9,1.651a1.16,1.16,0,0,0,.911,2.031l15.842-2.215a1.023,1.023,0,0,0,.871-1.155l-.465-3.323C2095.363,433.462,2091.575,432.947,2090.179,431.632Z",
    transform: "translate(-2012.026 -225.421)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M2065.156,395.473l.233,5.518s5.033.88,11.992,5.246l.406-10.014A85.137,85.137,0,0,1,2065.156,395.473Z",
    transform: "translate(-2019.93 -236.954)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M2089.2,395.394l1.491,8.141s3.344-4.234,11.334-7.818l-.332-3.234S2097.826,394.161,2089.2,395.394Z",
    transform: "translate(-2011.563 -237.994)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M2090.266,316.079s.892-1.259,3.462-.448,8.857,10.929,8.857,10.929Z",
    transform: "translate(-2011.194 -264.828)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M2089.405,293.532c-.494,5.433-7.963,9.64-10.208,9.64-4.85,0-8.383-7.164-8.614-7.8",
    transform: "translate(-2018.042 -272.422)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 56.292,
    cy: 56.292,
    r: 56.292,
    transform: "translate(0 40.629) rotate(-21.154)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M2097.148,261.114a68.927,68.927,0,1,0,68.927,68.928A68.927,68.927,0,0,0,2097.148,261.114Zm0,125.22a56.293,56.293,0,1,1,56.292-56.292A56.293,56.293,0,0,1,2097.148,386.334Z",
    transform: "translate(-2024.335 -257.228)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308",
    transform: "translate(100.147 40.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M2104.3,303.079c-2.4-4.292-2.207-8.961.424-10.429s6.7.818,9.1,5.11,2.207,8.96-.423,10.428S2106.7,307.369,2104.3,303.079Z",
    transform: "translate(-2098.597 -286.574)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M2100.29,292.545a2.73,2.73,0,1,1,3.923.539A2.8,2.8,0,0,1,2100.29,292.545Z",
    transform: "translate(-2099.636 -288.027)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309",
    transform: "translate(8.445 82.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M2046.036,320.343c-3.076-.658-6.6-1.252-7.557-.775a30.969,30.969,0,0,0-4.691,3.274,9.507,9.507,0,0,0-2.133,2.173c-.334.679.971.338,2.436-.141.849-.274,1.743-.6,2.41-.8.216-.069.415-.12.57-.156.941-.218,3.374.743,4.579,1.194a20.839,20.839,0,0,0,4.173,1.126",
    transform: "translate(-2031.604 -319.395)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(2000.589 414.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M1961.156,357.238c-1.718,2.447-5.039,1.635-6.581.133s-2.19-3.661-2.786-5.718c-1.348-4.719-2.705-9.665-1.7-14.467a8.149,8.149,0,0,1,1.851-3.928,4.2,4.2,0,0,1,3.979-1.317c1.677.442,2.726,2.057,3.477,3.652a34.49,34.49,0,0,1,3.383,14.8,11.91,11.91,0,0,1-1.625,6.849",
    transform: "translate(-1937.325 -331.855)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M1954.405,358.2a14.792,14.792,0,0,0-9.3.616,7.642,7.642,0,0,0-4.082,2.87c-.82,1.306-.654,3.557.813,4.388a4.4,4.4,0,0,0,2.955.182c2.394-.456,4.967-1.4,7.152-.313,1.236.613,2.223,1.839,3.6,1.995a3.145,3.145,0,0,0,3.115-2.172,5.346,5.346,0,0,0-.353-3.952A6.028,6.028,0,0,0,1954.405,358.2Z",
    transform: "translate(-1940.53 -322.854)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M1963.176,363.966a8.9,8.9,0,0,1-.716-8.31,15.771,15.771,0,0,1,5.411-6.622,25.962,25.962,0,0,1,9.073-4.429,9.148,9.148,0,0,1,3.948-.344,4.113,4.113,0,0,1,3.11,2.24c.774,1.816-.307,3.844-1.359,5.493a66.537,66.537,0,0,1-6.392,8.194c-1.888,2.056-4.019,4.061-6.692,4.847s-5.369.446-6.6-1.468",
    transform: "translate(-1933.147 -327.567)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M1946.547,360.491a5.684,5.684,0,0,1,1.112-.21,8.41,8.41,0,0,1,3.064.2,10.076,10.076,0,0,1,4.046,2.131,18.951,18.951,0,0,1,3.624,4.251,32.643,32.643,0,0,1,2.572,4.944,39.678,39.678,0,0,1,1.417,4.315c.333,1.256.557,2.271.717,3a6,6,0,0,1,.174,1.024",
    transform: "translate(-1938.437 -321.986)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M1953.969,339.128a3.265,3.265,0,0,1,.175.484l.431,1.419c.185.607.38,1.367.6,2.251s.473,1.892.71,3.014a166.623,166.623,0,0,1,2.828,17.686c.75,6.95,1.089,13.285,1.109,17.871,0,2.293,0,4.112-.082,5.429,0,.607-.072,1.089-.092,1.48a3.48,3.48,0,0,1-.093.5",
    transform: "translate(-1935.854 -329.325)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M1958.1,380.956a11.076,11.076,0,0,1,.125-1.538,40.647,40.647,0,0,1,.815-4.122,58.244,58.244,0,0,1,4.968-12.92A38.3,38.3,0,0,1,1972.4,351.4a16.752,16.752,0,0,1,1.885-1.488c.284-.2.538-.411.8-.576l.713-.407a11.111,11.111,0,0,1,1.357-.727",
    transform: "translate(-1934.416 -326.167)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314",
    transform: "translate(8.966 54.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M1947.182,372.5l5.195,25.628H1971.6l5.022-23.978Z",
    transform: "translate(-1947.182 -372.502)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(8.966 77.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M1947.182,389.716l2.771,3.81h23.364l3.3-3.81Z",
    transform: "translate(-1947.182 -389.716)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(3.841 51.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    transform: "translate(0.068 0.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1403",
    "data-name": "Rectangle 1403",
    width: 39.51,
    height: 7.923,
    fill: "#1a1a1a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M1983.026,377.861H1943.38v-8.12h39.646Zm-39.51-.2h39.374v-7.725h-39.374Z",
    transform: "translate(-1943.38 -369.741)",
    fill: "#1a1a1a"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328",
    transform: "translate(1775.681 421.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M1943.514,336.631v75.4H1773.676V393.156h18.871V374.285h18.871V355.414h18.871V336.543Z",
    transform: "translate(-1773.676 -336.543)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(1863.662 207.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M1864.525,202.792l-.007,1.4s.38,4.369-5,5.008-9.372-.815-9.227-4.188a48.553,48.553,0,0,0,.97-7.45,15.286,15.286,0,0,0-.191-2.615l10.424-.209,3.07.5Z",
    transform: "translate(-1835.001 -172.018)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M1857.113,338.413a24.167,24.167,0,0,0-1.654-6.2c-1.155-2.31-8.508-.84-8.508-.84s-1.471,1.26-1.785,7.143Z",
    transform: "translate(-1836.783 -124.637)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M1872.878,339.61c-1.728-1.055-.745-8.922-.745-8.922s8.05-6.44,9.158-1.51,7.646,7.145,11.371,7.749c2.569.416,3.366,1.84,3.611,2.682Z",
    transform: "translate(-1827.497 -125.887)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M1863.3,308.989a37.236,37.236,0,0,1,.591,4.348c.748,14.6,12.287,47.974,14.351,48.752,3.195,1.205,8.224-1.356,10.854-2.194a2.258,2.258,0,0,0,1.584-2.564c-5.714-26.271-7.814-64.1-8.578-86.5a101.7,101.7,0,0,0-2.322-19.073s-28.143-7.509-28.311,1.99C1851.317,262.158,1860.788,295.122,1863.3,308.989Z",
    transform: "translate(-1834.592 -153.156)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M1873.037,253.421l-14.877,107.83s-6.533,1.576-11.615.315c0,0-4.357-57.349-3.993-71.214s-3.127-37.1.8-39.661S1873.037,253.421,1873.037,253.421Z",
    transform: "translate(-1838.07 -152.792)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M1840.713,268.238a2.064,2.064,0,0,0,1.489,2.132c2.076.6,4.468,1.022,9.084,1.977a88.005,88.005,0,0,0,17.331,1.742c11.4.073,15.71-3.855,15.71-3.855.491.009-.259-2.376-.935-13.717-.228-3.842-.449-8.712-.609-14.866-.143-5.537-.24-12.115-.249-19.921-.013-9.388-14.544-19.488-14.813-19.488l0,0c0,1.352-2.131,3.847-5.412,4.061-3.9.255-8.674-1.684-8.674-3.927,0-.023-7.04,11.263-9.541,23.288C1842.829,231.723,1843.34,231.559,1840.713,268.238Z",
    transform: "translate(-1838.335 -169.405)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M1849.013,233.84c2.205,5.485,26.066,8.319,31.49,8.895-.229-2.379-.45-5.393-.61-9.2Z",
    transform: "translate(-1835.445 -158.519)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M1864.363,195.235l-.041,7.556a8.808,8.808,0,0,1-3.756.829c-4.792,0-7.888-3.513-9.506-6.063a15.261,15.261,0,0,0-.191-2.615l10.424-.209Z",
    transform: "translate(-1834.799 -172.018)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M1850.715,197.875c1.209,6.509,9.608,6.3,13.238,5.886,1.021-.113,1.665-.244,1.665-.244,1.151-.307,1.794-2.122,2.092-4.5.593-4.7-.156-11.606-.95-13.371-1.2-2.657-3.448-5.529-11.9-3.456S1849.164,189.536,1850.715,197.875Z",
    transform: "translate(-1835.445 -176.628)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M1870.307,180.706a28.011,28.011,0,0,1-8.115-2.2c-3.564-1.55-8.061.156-9.519.926a2.159,2.159,0,0,1,.356-.879,1.956,1.956,0,0,0-.752,1.115c-.068.05-.1.084-.081.1a2.512,2.512,0,0,0-1.22.078s.334-.047.453.167a.227.227,0,0,0,.054.059c-5.559,2.686-6.072,11.474-4.284,13.506a70.538,70.538,0,0,1,5.4,7.98,10.033,10.033,0,0,0-.12-3.479c-.391-2.153,1.468-2.153,3.816-3.131s.392-3.718,2.446-5.381,9.588-.685,9.491-1.957C1871.031,186.591,1870.307,180.992,1870.307,180.706Z",
    transform: "translate(-1836.396 -177.881)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M1852.66,231.487c.458.108.916.206,1.384.278a17.026,17.026,0,0,0,3.7-2.293c-1.771.35-2.887.585-2.887.585a7.118,7.118,0,0,0-1.609.909A5.288,5.288,0,0,0,1852.66,231.487Z",
    transform: "translate(-1834.176 -159.931)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M1859.609,199.578c1.2-.133,1.957-.287,1.957-.287,1.353-.361,2.11-2.495,2.46-5.289a6.685,6.685,0,0,0-4.187,3.424A4.916,4.916,0,0,0,1859.609,199.578Z",
    transform: "translate(-1831.761 -172.272)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M1865.409,202.84s4.7-7.76,1.046-8.1a5.532,5.532,0,0,0-5.655,3.048c-.528.909.137,5.01.137,5.01Z",
    transform: "translate(-1831.414 -172.026)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M1874.056,227.724a29.509,29.509,0,0,0,1.349,8.442c-5.244.566-13.57,1.979-17.239,2.7h-.009c-1.771.35-2.887.585-2.887.585a7.123,7.123,0,0,0-1.609.909,5.294,5.294,0,0,0-.584.522,5.508,5.508,0,0,0-1.609,4.064c13.173,2.824,32.813,1.763,32.813,1.763V246.7c1.17-.054,2.239-.89,3.13-2.832,3.714-8.156-3.417-32.7-6.664-37.257-1.852-2.589-7-3.669-11.113-4.127.008,1.061-.009,2.364-.073,3.831",
    transform: "translate(-1834.593 -169.323)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M1854.247,203.261s-9.961-.317-14.206,5.753c-2.6,3.705-.224,15.137,3.5,23.24a10.477,10.477,0,0,0,2.537,2.761c.206.216.414.414.63.62.333.306.674.612,1.016.909.287.252.575.495.872.72.333.27.665.531,1.007.774.233.179.468.341.711.5.161.117.323.225.477.324.224.154.458.3.692.441.09.054.171.108.261.162.233.136.476.271.711.406.576.314,1.151.6,1.744.853a3.555,3.555,0,0,0,.333.144,1.239,1.239,0,0,0,.2.081c.243.108.485.2.737.288.278.108.557.2.845.287.377.117.745.225,1.124.315a5.3,5.3,0,0,1,.584-.522,7.124,7.124,0,0,1,1.609-.908s1.116-.235,2.887-.585h.009c.027-.018.054-.044.081-.062.216-.181.431-.369.637-.558l.864-.828c.171-.171.333-.341.495-.522.215-.233.431-.476.637-.718s.4-.487.576-.729l3.912-6.986.379-.945.368-1.026c.108-.3.216-.62.316-.926.143-.422.27-.845.395-1.267.252-.828.477-1.673.683-2.51.108-.449.216-.89.306-1.33.135-.62.261-1.25.387-1.871.233-1.25.441-2.5.612-3.714a1.379,1.379,0,0,0,.018-.171q.094-.661.161-1.294c.027-.171.045-.333.063-.495.206-1.8.35-3.517.432-5.082.009-.179.017-.35.027-.522.018-.341.036-.674.045-1,.064-1.467.081-2.77.073-3.831,0-1.969-.073-3.157-.073-3.157-5.512-1.825-7.059,1.34-7.059,1.34s-6.5,15.477-9.883,25.584a41.842,41.842,0,0,1-2.158-10.109",
    transform: "translate(-1838.947 -170.284)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M1842.352,230.3a36.678,36.678,0,0,0,2.537,2.761c.206.216.414.414.63.62.333.306.674.612,1.016.909.287.252.576.495.872.72.333.27.665.531,1.007.774.233.179.468.341.711.5.161.117.323.225.477.324.224.154.458.3.692.441.09.054.171.108.261.162.233.136.476.271.71.406.576.314,1.151.6,1.744.853a3.536,3.536,0,0,0,.333.144,1.231,1.231,0,0,0,.2.081c.243.108.485.2.737.288.278.108.557.2.845.287.378.117.745.225,1.124.315a5.311,5.311,0,0,1,.584-.522,7.127,7.127,0,0,1,1.609-.908s1.116-.235,2.887-.585h.009c.027-.018.054-.044.081-.062.216-.181.431-.369.638-.558l.864-.828c.171-.171.333-.341.495-.522.215-.233.431-.476.637-.718s.4-.487.576-.729l3.912-6.986.379-.945.368-1.026c.108-.3.216-.62.316-.926.143-.422.27-.845.395-1.267.252-.828.477-1.673.683-2.51.108-.449.216-.89.306-1.33.135-.62.261-1.25.387-1.871.243-1.259.441-2.5.612-3.714a1.381,1.381,0,0,0,.018-.171q.094-.661.161-1.294c.027-.171.045-.333.064-.495.206-1.8.341-3.517.431-5.082.009-.179.017-.35.027-.522.018-.341.036-.674.045-1,0,0-5.781,20.962-13.641,28.29a8.594,8.594,0,0,1-4.451,2.428s-9.919-2.8-12.006-5.44A1.082,1.082,0,0,0,1842.352,230.3Z",
    transform: "translate(-1837.762 -168.334)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M1855.342,236.394a42.1,42.1,0,0,1-6.214-1.212c-.908-.454-5.068-6.365-2.344-7.88s10.036,4.545,10.036,4.545Z",
    transform: "translate(-1836.537 -160.771)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M1863.06,270.973l-3.192,27.75,3.674,21.9Z",
    transform: "translate(-1831.668 -145.492)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    x2: 58.712,
    transform: "translate(2033.799 496.707)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    x2: 17.641,
    transform: "translate(2061.328 490.61)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332",
    transform: "translate(2190.106 259.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(12.547 11.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M2108.044,233.84a8.8,8.8,0,1,0-15.036,6.217,9.992,9.992,0,0,1,2.586,4.44l.709,2.626h5.771l.672-2.487a10.017,10.017,0,0,1,2.666-4.518A8.776,8.776,0,0,0,2108.044,233.84Z",
    transform: "translate(-2090.438 -225.038)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M2099.139,249.532h-2.813a1.492,1.492,0,0,1-1.525-1.336l-.237-7.613,6.372-.04-.273,7.654A1.493,1.493,0,0,1,2099.139,249.532Z",
    transform: "translate(-2089.002 -219.643)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M2100.246,244.007c-1.781.075-3.567-.015-5.346.063",
    transform: "translate(-2088.885 -218.438)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    y1: 5.604,
    transform: "translate(20.814)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    x2: 4.412,
    y2: 3.455,
    transform: "translate(6.128 5.212)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    y1: 0.706,
    x2: 5.56,
    transform: "translate(35.726 19.221)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    x1: 5.56,
    y1: 0.706,
    transform: "translate(0 16.973)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    y1: 3.652,
    x2: 4.251,
    transform: "translate(32.427 6.171)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M2130.134,197.91a7.852,7.852,0,0,1-2.172.594,3.742,3.742,0,0,0,1.658-2.081,7.531,7.531,0,0,1-2.389.911,3.768,3.768,0,0,0-6.517,2.576,3.865,3.865,0,0,0,.087.859,10.663,10.663,0,0,1-7.764-3.94,3.766,3.766,0,0,0,1.158,5.034,3.72,3.72,0,0,1-1.7-.464v.042a3.785,3.785,0,0,0,3.018,3.7,3.763,3.763,0,0,1-.988.124,3.377,3.377,0,0,1-.713-.065,3.8,3.8,0,0,0,3.521,2.624,7.569,7.569,0,0,1-4.671,1.607,7.081,7.081,0,0,1-.9-.053,10.722,10.722,0,0,0,16.5-9.028c0-.167-.005-.328-.013-.487A7.512,7.512,0,0,0,2130.134,197.91Z",
    transform: "translate(119.634 35.832)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M2028.141,120.772c-6.347,0-9.721,4.068-9.721,8.5,0,2.057,1.148,4.622,2.988,5.436.526.236.456-.053.907-1.779a.41.41,0,0,0-.1-.4c-2.63-3.042-.513-9.3,5.549-9.3,8.774,0,7.134,12.141,1.526,12.141a2.07,2.07,0,0,1-2.181-2.54c.412-1.671,1.221-3.47,1.221-4.675,0-3.037-4.525-2.587-4.525,1.438a4.864,4.864,0,0,0,.44,2.083s-1.456,5.882-1.726,6.981a15.583,15.583,0,0,0,.106,5.132.152.152,0,0,0,.278.07,18.16,18.16,0,0,0,2.4-4.513c.179-.662.917-3.344.917-3.344a4,4,0,0,0,3.374,1.609c4.435,0,7.64-3.9,7.64-8.735-.015-4.637-3.983-8.106-9.092-8.106Z",
    transform: "translate(87.159 9.608)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(2224.908 135.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M2110.46,147.667V137.226h-3.513v-4.068h3.513v-3c0-3.48,2.126-5.378,5.232-5.378a29,29,0,0,1,3.138.16v3.639h-2.154c-1.689,0-2.015.8-2.015,1.981v2.6h4.031l-.527,4.068h-3.5v10.441Z",
    transform: "translate(-2106.948 -124.778)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M2085.807,108.634a3.334,3.334,0,0,0-2.344-2.345c-2.081-.569-10.408-.569-10.408-.569s-8.326,0-10.409.547a3.4,3.4,0,0,0-2.344,2.367,37.69,37.69,0,0,0,0,12.8,3.335,3.335,0,0,0,2.344,2.344c2.1.57,10.409.57,10.409.57s8.327,0,10.408-.549a3.33,3.33,0,0,0,2.344-2.344,35.062,35.062,0,0,0,.549-6.4A33.363,33.363,0,0,0,2085.807,108.634Zm-15.4,10.386v-7.976l6.924,3.989Z",
    transform: "translate(101.54 4.371)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    transform: "translate(2011.12 104.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M1948.343,148.038s11.412-21.632,33.727-30.254c0,0-13.459-.851-21.808,6.847,0,0,9.073-12.511,27.828-19.211",
    transform: "translate(-1948.343 -99.956)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M1978.958,111.528l-3.405-8.483a1.221,1.221,0,0,1,1.612-1.577l5.943,2.539a1.219,1.219,0,0,1,.643,1.6l-2.538,5.943A1.221,1.221,0,0,1,1978.958,111.528Z",
    transform: "translate(-1938.908 -101.367)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    transform: "translate(2190.551 174.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M2092.431,161.567a2.949,2.949,0,1,0,2.955,2.955A2.954,2.954,0,0,0,2092.431,161.567Zm0,0a2.949,2.949,0,1,0,2.955,2.955A2.954,2.954,0,0,0,2092.431,161.567ZM2103.346,160a7.837,7.837,0,0,0-.514-2.662,5.655,5.655,0,0,0-3.2-3.216,7.946,7.946,0,0,0-2.664-.5c-1.182-.058-1.55-.078-4.533-.078s-3.349.02-4.522.069a7.917,7.917,0,0,0-2.662.512,5.6,5.6,0,0,0-3.207,3.205,8.215,8.215,0,0,0-.512,2.663c-.058,1.182-.069,1.55-.069,4.533s.011,3.35.069,4.513a7.853,7.853,0,0,0,.512,2.662,5.25,5.25,0,0,0,1.259,1.946,5.4,5.4,0,0,0,1.948,1.27,7.924,7.924,0,0,0,2.662.5c1.162.058,1.541.067,4.522.067s3.351-.009,4.524-.067a7.978,7.978,0,0,0,2.662-.5,5.605,5.605,0,0,0,3.207-3.216,7.909,7.909,0,0,0,.512-2.662c.049-1.173.069-1.541.069-4.524S2103.394,161.171,2103.346,160Zm-10.916,9.945a5.427,5.427,0,1,1,5.432-5.421A5.422,5.422,0,0,1,2092.431,169.943Zm5.869-9.973a1.312,1.312,0,1,1,0-2.624,1.324,1.324,0,0,1,1.317,1.317A1.31,1.31,0,0,1,2098.3,159.97Zm-5.869.686a3.86,3.86,0,1,0,3.867,3.867A3.866,3.866,0,0,0,2092.431,160.656Z",
    transform: "translate(-2081.459 -153.539)",
    fill: "#1b1a19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M1804.665,298.358c-.05,0-.07-.039-.1-.066l-4.959-4.808q-2.529-2.451-5.063-4.9c-.1-.1-.1-.15-.014-.255a28.291,28.291,0,0,1,4.093-4.121c.082-.069.128-.057.2.009,1.925,1.8,3.848,3.6,5.716,5.459.093.093.143.1.239,0q3.239-3.142,6.482-6.277l10.49-10.155c.408-.4.82-.791,1.227-1.189.069-.069.116-.085.2-.011,1.291,1.14,2.583,2.279,3.816,3.483.092.089.105.138.007.236q-3.89,3.933-7.776,7.869-7.212,7.3-14.423,14.6C1804.758,298.286,1804.725,298.34,1804.665,298.358Z",
    transform: "translate(9.24 62.226)",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 1.767,
    cy: 1.767,
    r: 1.767,
    transform: "translate(2232.588 174.548)",
    fill: "#1b1a19"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 6.074,
    cy: 6.074,
    r: 6.074,
    transform: "translate(1851.514 141.388)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 4.296,
    cy: 4.296,
    r: 4.296,
    transform: "translate(1767.911 389.063)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 2.476,
    cy: 2.476,
    r: 2.476,
    transform: "translate(1773.569 402.542)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 2.476,
    cy: 2.476,
    r: 2.476,
    transform: "translate(2103.102 395.179)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 6.074,
    cy: 6.074,
    r: 6.074,
    transform: "translate(1851.514 134.406)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesImg2);
export default __webpack_public_path__ + "static/media/Services_img_2.8fc3f1516d5b148ce1ebb9a18ebf2fde.svg";
export { ForwardRef as ReactComponent };